'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pageExport = require('../pageExport');

var _pageExport2 = _interopRequireDefault(_pageExport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isIn() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var array = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return array.indexOf(value) >= 0;
} //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    current: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageSizeOpts: {
      type: Array,
      default: function _default() {
        return [10, 20, 30, 40];
      }
    },
    /*条数切换弹窗的展开方向，可选值为 bottom 和 top*/
    placement: {
      validator: function validator(value) {
        return isIn(value, ['top', 'bottom']);
      },

      default: 'bottom'
    },
    /*是否将弹层放置于 body 内，在 Tabs、带有 fixed 的 Table 列内使用时，建议添加此属性，它将不受父级样式影响，从而达到更好的效果*/
    transfer: {
      type: Boolean,
      default: false
    },
    size: {
      validator: function validator(value) {
        return isIn(value, ['small']);
      }
    },
    simple: {
      type: Boolean,
      default: false
    },
    showTotal: {
      type: Boolean,
      default: false
    },
    showElevator: {
      type: Boolean,
      default: false
    },
    showSizer: {
      type: Boolean,
      default: false
    },
    className: {
      type: String
    },
    styles: {
      type: Object
    }
  },
  components: {
    Page: _pageExport2.default
  },
  methods: {
    onChange: function onChange() {
      this.$emit.apply(this, ['on-change'].concat(Array.prototype.slice.call(arguments)));
    },
    onPageSizeChange: function onPageSizeChange() {
      this.$emit.apply(this, ['on-page-size-change'].concat(Array.prototype.slice.call(arguments)));
    },
    changePage: function changePage() {
      var PageInstance = this.$refs.Page;
      var target = PageInstance.$el.querySelector('.ivu-page-options-elevator input');
      var page = ~~target.value;
      if (page > PageInstance.allPages) {
        page = PageInstance.allPages;
      } else if (page <= 0 || !page) {
        page = 1;
      }
      PageInstance.changePage(page);
    }
  }
};